import { useEffect, useState } from 'react'
import { useAuth } from '../../../../../context/AuthContext'
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { formatMoney } from '../../../../../Utils/formatMoney'
import { api } from '../../../../../services/api'
import { ExportFiles } from '../ExportFiles'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import moment from 'moment'
import { download_csv } from '../JsonToCsv'
import { FiMoreVertical } from 'react-icons/fi'

import { ContainerLoading, Container, TableProducts } from './style'


export function MonthlyBalanceDetailedInformations() {
    const monthlyDatas = useSelector(state => state.modalCentralized.datasComponent)
    const { signOut } = useAuth()
    const [monthlyBalance, setMonthlyBalance] = useState([])
    const [loading, setLoading] = useState(false)
    const [isOpenExportFiles, setIsOpenExportFiles] = useState(false)

    function handleDownloadCSV() {
        const titleCSV = `FaturamentoMensal_${
                moment(monthlyDatas.startDate).format('DD-MM-YYYY-HH:mm')
            }ate${
                moment(monthlyDatas.endDate).format('DD-MM-YYYY-HH:mm')
            }`

        const arr = monthlyBalance.map((data) => {
            return({
                Mês: data.month,
                Valor: Number(data.credits).toFixed(2).replace('.',','),
                Mês_Ano_Pasado: data.monthLastYear,
                Valor_Mês_Ano_Passado: Number(data.creditsMonthLastYear).toFixed(2).replace('.',',')
            })
        })


        download_csv(arr, titleCSV)
    }

    useEffect(() => {
        setLoading(true)

        api.post('/getBalance' , monthlyDatas, {
            headers: {
                'Content-Type': 'application/json',
                token: localStorage.getItem('@Inoveclube:token')
            }
        })
        .then(response => {
            const listFormatted = response.data.map(data => {
                const credits = Number(data.credits.toFixed(2))

                return {
                    ...data,
                    credits
                }
            })
            
            setMonthlyBalance(listFormatted)
        })
        .catch(error => {
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                  signOut()
                  toast.warning('Sua sessão foi expirada')
                }else{
                  toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }   
        })
        .finally(() => setLoading(false))
    }, [monthlyDatas, signOut])
    

    
    if(loading)
        return(
            <ContainerLoading>

                 <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
                 
            </ContainerLoading>
        )  

    return (
        <Container>
            <div className="seeMore"> 
                <FiMoreVertical 
                    onClick={() => setIsOpenExportFiles(true)}
                />
                
                <ExportFiles 
                    handleDownloadCSV={handleDownloadCSV}
                    pdfButtonIsVisible={false}
                    isOpen={isOpenExportFiles}
                    setIsOpen={setIsOpenExportFiles}
                />
            </div>

            <TableProducts>
                <thead>
                    <tr>
                        <th>Mês/Ano Atual</th>
                        <th>Valor</th>
                        <th>Mês/Ano Passado</th>
                        <th>Valor</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        monthlyBalance.map((data) => {
                            return(
                                <tr key={data.month}>
                                    <td>{data.month}</td>
                                    <td>{formatMoney(data.credits)}</td>
                                    <td>{data.monthLastYear}</td>
                                    <td>{formatMoney(data.creditsMonthLastYear)}</td>
                                </tr>
                            )
                        })
                    }
                    <tr>
                        <td>Total</td>
                        <td>
                            {
                                formatMoney(
                                    monthlyBalance.map((data) => {
                                        return data.credits
                                    })
                                    .reduce((value,next) => {
                                        return value + next
                                    },0)
                                )
                            }
                        </td>
                        <td></td>
                        <td>
                            {
                                formatMoney(
                                    monthlyBalance.map((data) => {
                                        return data.creditsMonthLastYear
                                    })
                                    .reduce((value,next) => {
                                        return value + next
                                    },0)
                                )
                            }
                        </td>
                    </tr>
                </tbody>
            </TableProducts>
        </Container>
    )
}